import { last } from 'lodash-es';
import type { Collection } from '@/hooks/collections/use-collections';
import { ConversationMessageContentType, type ConversationMessageTypeUnion } from '@/models/conversations/conversation';
import type { DownloadFileType } from '@/models/messages/comm-message';
import { getSafeMediaUrl } from '@/utils/media-url';
import { parseUrl } from '@/utils/parse-url';

interface DownloadParams {
  key: string;
  url: string;
  type: DownloadFileType;
}

export function getMessageDownloadParams(
  message: Pick<ConversationMessageTypeUnion, 'Message' | 'MsgType'>,
): DownloadParams | null {
  switch (message.MsgType) {
    case ConversationMessageContentType.Image:
    case ConversationMessageContentType.Video: {
      const src = message.Message;
      const safeImageSrc = getSafeMediaUrl(src);
      return {
        key: parseUrl(src)?.pathname?.split('/').pop() ?? last(src.split('/')) ?? message.MsgType,
        url: safeImageSrc,
        type: message.MsgType,
      };
    }
    case ConversationMessageContentType.File: {
      const [url, filename = ''] = message.Message.split('|');

      if (!url) return null;
      const safeURL = getSafeMediaUrl(url);
      return {
        key: filename,
        url: safeURL,
        type: message.MsgType,
      };
    }
    default:
      return null;
  }
}

export function getCollectionDownloadParams(collection: Collection): DownloadParams | null {
  switch (collection.Type) {
    case ConversationMessageContentType.Image:
    case ConversationMessageContentType.Video: {
      const src = collection.Content;
      const safeImageSrc = getSafeMediaUrl(src);
      return {
        key: parseUrl(src)?.pathname?.split('/').pop() ?? last(src.split('/')) ?? collection.Type,
        url: safeImageSrc,
        type: collection.Type,
      };
    }
    case ConversationMessageContentType.File: {
      const [filename = ''] = collection.Content.split('|');
      const url = collection.SmallPicturePath;
      if (!url) return null;
      const safeURL = getSafeMediaUrl(url);
      return {
        key: filename,
        url: safeURL,
        type: collection.Type,
      };
    }
    default:
      return null;
  }
}
